'use client'

import React from 'react'
import { useStore } from '@/store'
import { AdvertisingModalEmbedded } from '@/AdvertisingModal/AdvertisingModalEmbedded'

// Free download signup content configuration
const freeDownloadContent = {
  title: 'Free Tricks!',
  introHtml:
    "<p>Enter your email address and we'll send you a video of our favorite easy magic tricks.</p>",
  imageUrl: '', // Remove image since we're handling images in the layout
  imageAlt: '',
  submitButtonText: 'Give Me the Free Tricks!',
  successMessage:
    "We've emailed you a link! Check your inbox for your free download!",
}

const freeDownloadConfig = {
  layout: 'stacked' as const, // Use stacked layout to match original inline form
  hideForLoggedInUsers: true,
  showFormForLoggedInUsers: false,
}

export const FreeDownloadSignupModal = () => {
  const user = useStore(state => state.user)
  if (user) {
    return null
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="hidden md:block md:col-span-3">
          <img
            src="https://vinc.gumlet.io/pics/easy-magic-tricks/reactions-circles.png?w=400&dpr=2"
            alt="People reacting to magic"
            className="w-full"
          />
        </div>
        <div className="md:col-span-6 w-full">
          <AdvertisingModalEmbedded
            content={freeDownloadContent}
            trackingEventName="Free Tricks signup"
            config={freeDownloadConfig}
            className="!bg-transparent !border-0 !shadow-none !p-0 !w-full"
            customInputClassName="w-full px-4 py-3 rounded-lg border border-gray-300 text-black text-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
            customButtonClassName="w-full text-lg py-3"
            customTitleClassName="text-3xl md:text-4xl font-archivo font-black mb-4 text-white"
            customIntroClassName="text-xl text-white leading-relaxed"
            customSuccessClassName="text-center py-12"
            customSuccessTitleClassName="text-lg font-semibold text-green-600 mb-2"
            customSuccessMessageClassName="text-green-600"
            hideTitleInSuccess={true}
            hideLabels={true}
            hideErrorBox={true}
          />
        </div>
        <div className="hidden md:block md:col-span-2">
          <img
            src="https://vinc.gumlet.io/pics/easy-magic-tricks/reactions-diamond.png?w=300&dpr=2"
            alt="Person learning a magic trick"
            className="w-full"
          />
        </div>
      </div>
    </div>
  )
}
